import {
  Box,
  List,
  ListItemText,
  CircularProgress,
  Typography,
  IconButton,
  ListItemIcon,
  useTheme,
} from '@mui/material'
import { ChatBubbleOutline, MoreHoriz, InfoOutlined } from '@mui/icons-material'
import { useChatStore } from '../../../stores/useChatStore'
import { useConversationManagement } from '../../../hooks/useConversationManagement'
import { useShallow } from 'zustand/react/shallow'
import { ThinScrollContainer } from '../../../styles/Common.styles'
import { StyledListItem } from './ChatHistoryList.styles'

const ChatHistoryList = ({ handleMenuOpen }) => {
  const theme = useTheme()
  const { handleSelectConversation } = useConversationManagement()
  const {
    conversations,
    selectedConversation,
    isSendingMessage,
    isLoadingConversations,
  } = useChatStore(
    useShallow(state => ({
      conversations: state.conversations,
      selectedConversation: state.selectedConversation,
      isSendingMessage: state.isSendingMessage,
      isLoadingConversations: state.isLoadingConversations,
    }))
  )
  return (
    <ThinScrollContainer>
      <List dense disablePadding>
        {/* --- Loading State --- */}
        {isLoadingConversations && (
          <Box display="flex" alignItems="center" gap={1} p={2}>
            <CircularProgress size={18} thickness={5} color="primary" />
            <Typography fontSize={13} color="text.secondary">
              Caricamento cronologia...
            </Typography>
          </Box>
        )}

        {!isLoadingConversations &&
          conversations.length > 0 &&
          conversations.map(conv => {
            const isSelected = selectedConversation?.id === conv.id
            const date = new Date(conv.updated_at).toLocaleDateString('it-IT', {
              day: '2-digit',
              month: 'short',
            })

            return (
              <StyledListItem
                key={conv.id}
                onClick={() => handleSelectConversation(conv)}
                isItemSelected={isSelected}
              >
                {/* Chat Icon */}
                <ListItemIcon
                  sx={{
                    minWidth: 30,
                    color: isSelected
                      ? theme.palette.primary.main
                      : theme.palette.text.secondary,
                  }}
                >
                  <ChatBubbleOutline fontSize="small" />
                </ListItemIcon>

                {/* Title and Date */}
                <ListItemText
                  primary={
                    <Typography
                      variant="body2"
                      noWrap
                      sx={{
                        fontWeight: isSelected ? 600 : 500,
                        color: isSelected
                          ? theme.palette.text.primary
                          : theme.palette.text.secondary,
                        fontSize: 13,
                      }}
                    >
                      {conv.title || 'Nuova Chat'}
                    </Typography>
                  }
                  secondary={
                    <Typography
                      variant="caption"
                      color="text.disabled"
                      sx={{ fontSize: 10 }}
                    >
                      {date}
                    </Typography>
                  }
                />

                {/* Menu Button */}
                <IconButton
                  edge="end"
                  size="small"
                  onClick={e => handleMenuOpen(e, conv)}
                  disabled={isSendingMessage}
                  sx={{
                    opacity: 0.7,
                    ml: 1,
                    color: isSelected
                      ? theme.palette.primary.main
                      : theme.palette.text.secondary,
                    '&:hover': { opacity: 1 },
                  }}
                >
                  <MoreHoriz fontSize="small" />
                </IconButton>
              </StyledListItem>
            )
          })}

        {/* --- Empty State --- */}
        {!isLoadingConversations && conversations.length === 0 && (
          <Box display="flex" flexDirection="column" alignItems="center" gap={1} p={2}>
            <InfoOutlined sx={{ fontSize: 28, color: 'text.disabled', mb: 0.5 }} />
            <Typography variant="body2" color="text.secondary" textAlign="center">
              Nessuna conversazione trovata.
            </Typography>
          </Box>
        )}
      </List>
    </ThinScrollContainer>
  )
}

export default ChatHistoryList
